import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { ExternalLinkSmallIcon } from '@/assets/icons/externalLinkSmall';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { useHover } from '@/feature/responsive-design/hooks/use-hover';
import { PRODUCT_SWITCHER_HEIGHT } from '@/utils/constants-platform-specific';

type DesktopProductTabProps = {
    label: string;
    active?: boolean;
    onPress: () => void;
    testID?: string;
};

/**
 * A single tab of the desktop web product switcher strip.
 */
export const DesktopProductTab = ({ label, active = false, onPress, testID }: DesktopProductTabProps) => {
    const { hovered, hoverHandlers } = useHover();

    return (
        <Pressable
            {...hoverHandlers}
            onPress={onPress}
            style={[styles.tab, hovered && !active ? styles.tabHovered : null]}
            accessibilityRole="button"
            accessibilityLabel={label}
            accessibilityState={{ selected: active }}
            testID={testID}
        >
            <Text
                variant="labelLarge2"
                color={active || hovered ? ds.colorToken.text.primary : ds.colorToken.text.secondary}
                numberOfLines={1}
            >
                {label}
            </Text>
            {!active ? <ExternalLinkSmallIcon fill={hovered ? ds.colorValue.icon.primary : undefined} /> : null}
        </Pressable>
    );
};

const styles = StyleSheet.create({
    tab: {
        alignItems: 'center',
        flexDirection: 'row',
        gap: 8,
        height: PRODUCT_SWITCHER_HEIGHT,
        justifyContent: 'center',
        paddingHorizontal: 8,
    },
    tabHovered: {
        backgroundColor: ds.colorValue.border.strong,
    },
});
